import { render } from "./NavBar.vue?vue&type=template&id=2a8a9dda&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=2a8a9dda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a8a9dda"

export default script